import { useEffect } from 'react';

import { useActions } from 'features/hooks/useRedux';
import { useCheckAuthorization } from 'api/auth/hooks/useCheckAuthorization';
import { Loader } from 'components/loader';
import { BLOGGER } from 'features/constants';

export const GetMe = ({ children }: { children?: React.ReactNode }) => {
  const { data: checkAuthData, isPending: isPendingCheckAuth } = useCheckAuthorization();

  const { setUser } = useActions();

  useEffect(() => {
    if (checkAuthData) {
      if (checkAuthData.user.roleId === BLOGGER && process.env.REACT_APP_LC_PATH) {
        window.location.replace(process.env.REACT_APP_LC_PATH);
        return;
      }
      setUser(checkAuthData.user);
    }
  }, [checkAuthData]);

  if (isPendingCheckAuth) {
    return <Loader />;
  }

  return <>{children}</>;
};
